import { FormattedMessage } from 'react-intl'
import { reCaptchaSiteKey } from 'Config'

import { useHistory } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'

import BackToLogin from '@/components/Login/BackToLogin'

import { RECOVER_PASSWORD } from '@/routes'

import './ResetPassword.scss'

const ResetPassword = () => {
  const history = useHistory()

  const onChange = value => {
    if (value.length) history.push(RECOVER_PASSWORD)
  }

  return (
    <div className="content-wrapper reset-password">
      <div className="login-titles">
        <h1 className="title">
          <FormattedMessage id="resetPassword.subTitle" />
        </h1>
      </div>
      <div className="login-form-wrapper">
        <ul className="login-field-wrapper">
          <li>
            <ReCAPTCHA
              sitekey={reCaptchaSiteKey}
              onChange={onChange}
            />
          </li>
          <li className="login-form-empty-space" />
        </ul>
      </div>
      <div className="login-buttons-wrapper">
        <BackToLogin />
      </div>
    </div>
  )
}

export default ResetPassword
